import { KeyboardArrowDown } from "@mui/icons-material";
import { Typography } from "@mui/material";

import MenuDropDownButton from "../../../../ui library/components/buttons/MenuDropDownButton";
import HNSColors from "../../../../ui library/HNSColors";
import { getMenuList } from "../../helper/function";
import useButtonActions from "../../hooks/useButtonActions";
import { useAISummaryStore } from "../../store/aiSummaryStore";
import sharedStyles from "../../styles/styles";
import { BUTTON_LABELS, DROPDOWN_OPTS } from "../../utils/strings";

export default function CopyNoteActionsMenu() {
  const { disableCopyButton } = useAISummaryStore();
  const { handleDropdownButtonClick } = useButtonActions();
  const menuList = getMenuList(DROPDOWN_OPTS, handleDropdownButtonClick);

  return (
    <MenuDropDownButton
      disabled={disableCopyButton}
      menuList={menuList}
      sx={{
        ...sharedStyles.menuDropdownButtonStyle,
        backgroundColor: !disableCopyButton ? HNSColors.secondary[500] : HNSColors.neutrals[800],
        color: !disableCopyButton ? HNSColors.neutrals[900] : HNSColors.neutrals[500],
      }}
      className="group min-w-[240px] rounded-[500px] px-4 font-normal normal-case"
    >
      <div className="flex w-full flex-row items-center justify-between py-1">
        <Typography className="w-full text-center text-xs font-normal group-hover:font-semibold">
          {BUTTON_LABELS.COPY_BUTTON}
        </Typography>
        <KeyboardArrowDown
          style={{
            color: !disableCopyButton ? HNSColors.neutrals[900] : HNSColors.neutrals[500],
          }}
        />
      </div>
    </MenuDropDownButton>
  );
}
